import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { COUPON_STATUS, DISCOUNT_CODE_TYPES } from "../../../../constants";
import classNames from "classnames";
import { sendMessageToParent } from "../../../../utils";
import copy from "copy-to-clipboard";

interface CouponsItemProps {
  data: ICouponsItem;
}

export interface ICouponsItem {
  create_time: string;
  discount_code_type: number;
  id: number;
  percentage: number;
  shopify_customer_id: number;
  shopify_discount_code: string;
  shopify_discount_code_id: number;
  source_type: number;
  status: number;
  update_time: string;
}

const CouponsItem: React.FC<CouponsItemProps> = ({ data }) => {
  const isCouponAvailable = useMemo(() => {
    return data.status === COUPON_STATUS.AVAILABLE;
  }, [data.status]);

  const handleCopy = () => {
    if (isCouponAvailable) {
      const isCopied = copy(data.shopify_discount_code, {
        debug: false,
        format: "text/plain",
      });

      isCopied &&
        sendMessageToParent({
          type: "member-toast",
          data: {
            type: "success",
            message: "Paste the code at the checkout to use",
            duration: 3000,
          },
        });
    } else {
      sendMessageToParent({
        type: "member-toast",
        data: {
          type: "error",
          message: "Coupon used",
          duration: 3000,
        },
      });
    }
  };

  return (
    <div key={data.id} className={styles.giftCardItem}>
      <div className={styles.giftCardLabel}>
        <span>Member Reward</span>
      </div>
      <div className={styles.giftCardContent}>
        <div className={styles.leftSection}>
          <div className={styles.amount}>
            {data.discount_code_type === DISCOUNT_CODE_TYPES.BASIC
              ? `${data.percentage * 100}% OFF`
              : "Free Shipping"}
          </div>

          <div className={styles.required}>
            {data.discount_code_type === DISCOUNT_CODE_TYPES.BASIC
              ? "No minimum spend required"
              : ""}
          </div>

          <div className={styles.codes}>Code:{data.shopify_discount_code}</div>
          <div className={styles.expired}>Expired in 30 days</div>
        </div>
        <div className={styles.rightSection}>
          <button
            data-element-id={`copy-coupon-code`}
            className={classNames(styles.copyButton, {
              [styles.disabled]: !isCouponAvailable,
            })}
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponsItem;
